export class RestoreBigQueryDatasetRequest {
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "BigQueryDatasetDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreBigQueryDatasetRequest.attributeTypeMap;
    }
    constructor() {
    }
}
